/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AttachmentFileTypeOut
 */
export interface AttachmentFileTypeOut {
    /**
     * 
     * @type {number}
     * @memberof AttachmentFileTypeOut
     */
    offerId: number;
    /**
     * 
     * @type {Date}
     * @memberof AttachmentFileTypeOut
     */
    modificationDate: Date;
    /**
     * 
     * @type {number}
     * @memberof AttachmentFileTypeOut
     */
    attachmentId: number;
    /**
     * 
     * @type {number}
     * @memberof AttachmentFileTypeOut
     */
    fileTypeId: number;
}

export function AttachmentFileTypeOutFromJSON(json: any): AttachmentFileTypeOut {
    return AttachmentFileTypeOutFromJSONTyped(json, false);
}

export function AttachmentFileTypeOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttachmentFileTypeOut {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'offerId': json['offerId'],
        'modificationDate': (new Date(json['modificationDate'])),
        'attachmentId': json['attachmentId'],
        'fileTypeId': json['fileTypeId'],
    };
}

export function AttachmentFileTypeOutToJSON(value?: AttachmentFileTypeOut | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'offerId': value.offerId,
        'modificationDate': (value.modificationDate.toISOString()),
        'attachmentId': value.attachmentId,
        'fileTypeId': value.fileTypeId,
    };
}


